import { MaximizeIcon } from "lucide-react";
import { FormattedMessage, useIntl } from "react-intl";
import type { ReportSectionMeta } from "~/api/model";
import { ReportCopyExportActions } from "~/components/ReportCopyExportActions";
import { TabControlBar } from "~/components/TabControlBar";
import { Button } from "~/components/ui/button";

export const ReportActions = ({
  disabled,
  onMaximize,
  reportId,
  reportSections,
  content,
  exportFileName,
  reportTitle,
  caseInfo,
}: {
  disabled: boolean;
  onMaximize: () => void;
  reportId?: string;
  reportSections?: ReportSectionMeta[];
  content: string;
  exportFileName: string;
  reportTitle?: string;
  caseInfo?: {
    caseName: string;
    dateOfBirth: string;
    dateOfLoss: string;
    claimNumber: string;
  };
}) => {
  const { formatMessage } = useIntl();

  return (
    <TabControlBar>
      <TabControlBar.Group>
        <Button
          variant="ghost"
          size="mini"
          disabled={disabled}
          onClick={onMaximize}
        >
          <MaximizeIcon className="w-4 h-4 mr-2" />
          <FormattedMessage id="common.maximize" defaultMessage="Maximize" />
        </Button>
        <ReportCopyExportActions
          content={content}
          reportId={reportId}
          reportSections={reportSections}
          fileName={exportFileName}
          title={reportTitle || formatMessage({ id: "chat.report.title" })}
          disabled={disabled}
          buttonSize="mini"
          copyEventName="app/report/copy_all.button/click"
          exportOpenEventName="app/report/export.button/click"
          exportEventName="app/report/export_menu_open/export_action.link/click"
          caseInfo={caseInfo}
        />
      </TabControlBar.Group>
    </TabControlBar>
  );
};
